/*
 |--------------------------------------------------------------------------
 | Questions / actions.js
 |--------------------------------------------------------------------------
 */

import { products } from '@/content/products'
import { hempelProducts } from '@/content/hempelproducts'
import * as mutation from './mutation_types'

export default {
    setBoatType({ commit }, type) {
        commit(mutation.SET_BOAT_TYPE, type)
    },
    setBoatMaterial({ commit }, material) {
        commit(mutation.SET_BOAT_MATERIAL, material)
    },
    setSailFrequency({ commit }, frequency) {
        commit(mutation.SET_SAIL_FREQUENCY, frequency)
    },
    setCountry({ commit }, country) {
        commit(mutation.SET_COUNTRY, country)
    },
    async getLocalProducts({ commit, getters }, key) {
        if (getters.localProducts(key)) {
            return
        }

        commit(mutation.LOCAL_PRODUCTS, { key, products: hempelProducts })
        return
    }
}
